import React, { useEffect, useState } from "react";
import { Row, Col, Spinner } from "react-bootstrap";
import StyledLink from "../../general/StyledLink";
import { estado_suscripciones } from "../../../services/admin";

import UserSubscriptionStatus from "./UserSubscriptionStatus";
import ActivationCodesTable from "./ActivationCodesTable";

const DashboardSuscripciones = () => {
  const [users, setUsers] = useState(null);

  const fetchData = async () => {
    const response = await estado_suscripciones();
    setUsers(response.users);
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (!users) {
    return (
      <Row>
        <Col className="text-center mt-4">
          <Spinner animation="border" />
        </Col>
      </Row>
    );
  }

  return (
    <div className="container">
      <Row className="mb-3">
        <Col xs={12}>
          <StyledLink to="/admin">← Tablas</StyledLink>
        </Col>
      </Row>

      <ActivationCodesTable />

      <hr className="my-5" />

      <UserSubscriptionStatus users={users} refresh={fetchData} />
    </div>
  );
};

export default DashboardSuscripciones;
